export default __webpack_public_path__ + "static/logo-bar-s-food-sigma-8b0d6f7c38ac1424c4582d52df8a3122.png";